import { render, staticRenderFns } from "./PrintersSetup.vue?vue&type=template&id=b304e99e&scoped=true&"
import script from "./PrintersSetup.vue?vue&type=script&lang=js&"
export * from "./PrintersSetup.vue?vue&type=script&lang=js&"
import style0 from "./PrintersSetup.vue?vue&type=style&index=0&id=b304e99e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b304e99e",
  null
  
)

export default component.exports